"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolbarExpandBtn = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const use_t_1 = require("use-t");
const ToolbarTextItem_1 = require("../ToolbarTextItem");
const context = tslib_1.__importStar(require("./context"));
const ToolbarExpandBtn = ({ small, disabled, tooltip, onClick }) => {
    const [t] = (0, use_t_1.useT)();
    const openPanel = context.useToolbarMenu()?.openPanel;
    return (React.createElement(ToolbarTextItem_1.ToolbarTextItem, { small: small, disabled: disabled, onMouseEnter: () => openPanel?.onMouseMove('_expand'), onMouseMove: () => openPanel?.onMouseMove('_expand'), onMouseLeave: openPanel?.onMouseLeave, onClick: onClick, tooltip: small && !disabled
            ? {
                renderTooltip: () => t('More'),
                ...tooltip,
            }
            : tooltip }, small ? void 0 : t('More')));
};
exports.ToolbarExpandBtn = ToolbarExpandBtn;
